import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchEngagementLetterTemplate } from '../../store/investor/investorApiHelper';
import { closeEngagementLetter, setEngagementLetterData } from '../../store/investor/action';
import { TEXT_EDITOR_TYPES } from '../../store/investor/constants';
import { AICA_ENGAGEMENT_LETTER_PREVIEW, AICA_ENGAGEMENT_LETTER_SAVE } from '../../utils/constants/mixpanelEvents/investorEvents';
import { useFeatureVisibility } from '../../utils/useVisibilityConfig';
import { VISIBILITY_KEYS } from '../../utils/constants/visibilityKeys';
import DocumentContainer from '../DocumentEditor/DocumentContainer';
import EngagementLetterV2 from './EngagementLetterV2';

function EngagementLetter() {
    const dispatch = useAppDispatch();
    const engagementLetterData = useAppSelector((state) => state.investor.engagementLetter);
    const { engagementLetterV2 } = useFeatureVisibility({ engagementLetterV2: VISIBILITY_KEYS.ENGAGEMENT_LETTER.V2 });

    if (engagementLetterV2.write) {
        return <EngagementLetterV2 />;
    }

    return (
        <DocumentContainer
            orgId={engagementLetterData.orgId ?? ''}
            source={engagementLetterData.source ?? ''}
            loading={!!engagementLetterData.loading}
            companyName={engagementLetterData.companyName ?? ''}
            onUnmount={() => dispatch(closeEngagementLetter())}
            setLoading={(loading) => dispatch(setEngagementLetterData({ loading }))}
            onSaveComplete={() => dispatch(closeEngagementLetter())}
            fetchTemplate={fetchEngagementLetterTemplate}
            docType="ENGAGEMENT_LETTER"
            regenTitle="Engagement Letter"
            editorType={TEXT_EDITOR_TYPES.ENGAGEMENT_LETTER}
            documentType="engagementLetter"
            fileNamePrefix="Engagement_Letter"
            commentContainerId="el-comment-container"
            mixpanelPreviewEvent={AICA_ENGAGEMENT_LETTER_PREVIEW}
            mixpanelSaveEvent={AICA_ENGAGEMENT_LETTER_SAVE}
        />
    );
}

export default EngagementLetter;
